import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Operatore, SearchResult} from '../_models/_Index';
import { environment } from '../../environments/environment';
import { Subject, firstValueFrom } from 'rxjs';
import {OperatoreSessione} from '../_models/OperatoreSessione';

@Injectable({ providedIn: 'root' })
export class OperatoriService {

  public handleSave: Subject<number> = new Subject();
  constructor(private http: HttpClient) { }

  async getOperatoreAsync(id: number) {
    return firstValueFrom(this.http.get<Operatore>(`${environment.localApiUrl}auth/Operatori/Operatore/${id}`));
  }

  async getOperatorisAsync() {
    return firstValueFrom(this.http.get<Operatore[]>(`${environment.localApiUrl}auth/Operatori/Operatori`));
  }

  async setOrganizzazioneAsync(orgId: number) {
    return firstValueFrom(this.http.get<number>(`${environment.localApiUrl}auth/Operatori/SetOrganizzazione/${orgId}`));
  }

  async getOperatoreByEmailAsync(email: string) {
    return firstValueFrom(this.http.get<Operatore>(`${environment.localApiUrl}auth/Operatori/OperatoreEmail/${email}`));
  }

  async updateOperatoreAsync(operatore: Operatore) {
    return firstValueFrom(this.http.post<Operatore>(`${environment.localApiUrl}auth/Operatori/UpdateOperatore`, operatore));
  }

  async deleteOperatoreAsync(id: number) {
    return firstValueFrom(this.http.get(`${environment.localApiUrl}auth/Operatori/DeleteOperatore/${id}`));
  }

  async getOperatoreSessioniAsync(id: number, page: number, count: number) {
    return firstValueFrom(this.http
      .get<SearchResult<OperatoreSessione>>(`${environment.localApiUrl}auth/Operatori/OperatoreSessioni/${id}/${page}/${count}`));
  }
}
